import { PASSPORT_REQUEST, PASSPORT_REQUEST_ERROR, PASSPORT_REQUEST_SUCCESS, SELECTED_HEALTH_REC_ID, SELECTED_HEALTH_REC_ID_ERROR, SELECTED_HEALTH_REC_ID_SUCCESS, SELECTED_PRESCRIPTION_ID, SELECTED_PRESCRIPTION_ID_ERROR, SELECTED_PRESCRIPTION_ID_SUCCESS } from './Constants';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};
  
export const passportReducer = (state = initialState, action) => {
    switch (action.type) {
    case PASSPORT_REQUEST:        
        return { ...state,loading: true };
    case PASSPORT_REQUEST_SUCCESS :                
        return { ...state, passportData : action.data, loading: false };
    case PASSPORT_REQUEST_ERROR :
        return { ...state,loading: false };
    case SELECTED_PRESCRIPTION_ID :
        return { ...state, loading: false };
    case SELECTED_PRESCRIPTION_ID_SUCCESS :
        return { ...state, prescriptionData : action.prescriptionData , loading: false};
    case SELECTED_PRESCRIPTION_ID_ERROR :
        return { ...state , loading: false};
    case SELECTED_HEALTH_REC_ID :
        return { ...state, loading: false };
    case SELECTED_HEALTH_REC_ID_SUCCESS :
        return { ...state, healthRecData : action.healthRecData , loading: false};
    case SELECTED_HEALTH_REC_ID_ERROR :
        return { ...state , loading: false};
    default:
        return state;
    }
};
  